import PrioritizedWikiList from "./PrioritizedWikiList";

import "./PrioritizedWikiList.scss";

export * from "./PrioritizedWikiList.types";

export { PrioritizedWikiList };